namespace SP {

    export async function blurActive() {
        (document.activeElement as HTMLElement).blur();
        await SP.sleep(0);
    }
}